import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { adPositionConfigAll } from "@/api/config";
export var adPosition = {
  namespaced: true,
  state: {
    isInit: 0,
    adPositionKv: {}
  },
  mutations: {
    setAdpositionkKv: function setAdpositionkKv(state, adPositionMap) {
      state.isInit = 1;
      state.adPositionKv = adPositionMap;
    }
  },
  actions: {
    getAdPosition: function getAdPosition(_ref) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var commit, state, res, adPositionMap;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit, state = _ref.state;
              if (!(state.isInit == 0)) {
                _context.next = 6;
                break;
              }
              _context.next = 4;
              return adPositionConfigAll();
            case 4:
              res = _context.sent;
              if (res.code == 0) {
                adPositionMap = {};
                res.data.forEach(function (val) {
                  adPositionMap[val.position_id] = val.position_name;
                });
                commit("setAdpositionkKv", adPositionMap);
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  },
  //派生状态
  getters: {
    adPositionMap: function adPositionMap(state) {
      return state.adPositionKv;
    }
  }
};